import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Input, Row, theme, Typography } from 'antd';
import { PosFormItem } from 'pos-client/components/shared/Form/PosFormItem.tsx';
import type { ModeType } from 'pos-client/pages/locations/Modals/useModalType.tsx';
import type { LocationCreateEditModel } from 'pos-shared/models/locationSchema.ts';

export const LocationBasicDetailsTab = ({
  locationForm,
  mode,
}: {
  locationForm: UseFormReturn<LocationCreateEditModel>;
  mode: ModeType;
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <>
      <Row gutter={[token.marginSM, 0]}>
        <Col span={12}>
          <PosFormItem
            name="name"
            control={locationForm.control}
            label={t('locations.serviceLocationName')}
            formItemProps={{
              style: { marginBottom: location ? token.marginMD : 0 },
            }}
          >
            <Input />
          </PosFormItem>
          {!location && (
            <Typography.Text
              type="secondary"
              style={{
                display: 'inline-block',
                marginBottom: token.marginMD,
              }}
            >
              {t('locations.newServiceLocationHint')}
            </Typography.Text>
          )}
        </Col>
        <Col span={12}>
          <PosFormItem
            name="code"
            control={locationForm.control}
            label={t('common.words.code')}
            formItemProps={{
              style: { marginBottom: location ? token.marginMD : 0 },
            }}
          >
            <Input disabled={mode === 'edit'} />
          </PosFormItem>
          {!location && (
            <Typography.Text
              type="secondary"
              style={{
                display: 'inline-block',
                marginBottom: token.marginMD,
              }}
            >
              {t('locations.newLocationCodeHint')}
            </Typography.Text>
          )}
        </Col>
      </Row>

      <Row gutter={[token.marginSM, 0]}>
        <Col span={location ? 24 : 12}>
          <PosFormItem
            name="contact.emailAddress"
            control={locationForm.control}
            label={t('common.contact.emailAddress')}
          >
            <Input />
          </PosFormItem>
        </Col>
        <Col span={12}>
          <PosFormItem
            name="contact.telephone"
            control={locationForm.control}
            label={t('common.contact.phoneNumber')}
          >
            <Input />
          </PosFormItem>
        </Col>

        {location && (
          <Col span={12}>
            <PosFormItem
              name="contact.fax"
              control={locationForm.control}
              label={t('common.contact.fax')}
            >
              <Input />
            </PosFormItem>
          </Col>
        )}
      </Row>
    </>
  );
};
